/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectBillingAccountInput
 */
export interface ProjectBillingAccountInput {
    /**
     * 
     * @type {string}
     * @memberof ProjectBillingAccountInput
     */
    billingAccountId?: string;
}

/**
 * Check if a given object implements the ProjectBillingAccountInput interface.
 */
export function instanceOfProjectBillingAccountInput(value: object): value is ProjectBillingAccountInput {
    return true;
}

export function ProjectBillingAccountInputFromJSON(json: any): ProjectBillingAccountInput {
    return ProjectBillingAccountInputFromJSONTyped(json, false);
}

export function ProjectBillingAccountInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectBillingAccountInput {
    if (json == null) {
        return json;
    }
    return {
        
        'billingAccountId': json['billingAccountId'] == null ? undefined : json['billingAccountId'],
    };
}

export function ProjectBillingAccountInputToJSON(json: any): ProjectBillingAccountInput {
    return ProjectBillingAccountInputToJSONTyped(json, false);
}

export function ProjectBillingAccountInputToJSONTyped(value?: ProjectBillingAccountInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingAccountId': value['billingAccountId'],
    };
}

